import Vue from 'vue'
import Router from 'vue-router'
import store from './store/store'
import routes from './routes'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  linkExactActiveClass: 'active',
  routes
})

router.beforeEach((to, from, next) => {
  // Redirect to login page if not logged in and trying to access a restricted page
  const authRequired = !to.meta.guest
  const loggedIn = store.state.user.logged

  let params = {}
  if (from.query.law_firm_id !== undefined) {
    params.law_firm_id = from.query.law_firm_id
  }

  if (authRequired && !loggedIn) {
    return next({ name: 'login' })
  } else if (!loggedIn) {
    //  this action will clean the store
    store.dispatch('user/logout', { noRedirect: true, query: params })
  } else if (loggedIn && to.name === 'login') {
    return next({ name: 'home' })
  }

  /* Redirect to law firm selection page, if :
    1) No law firm is selected.
    2) Only for page where authentication is mandatory.
    3) User is not already on law firm selection page.
   */
  if (!store.state.lawFirms.selected && to.meta.guest !== true && to.name !== 'law-firm-selection') {
    return next({ name: 'law-firm-selection', query: params })
  }

  next()
})

export default router
